import React, {useState} from "react";
import {Button, Card, Image, Input, Modal, Row, Space, Typography} from "antd";
import SimpleTips from "../../containers/SimpleTips";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useMount} from "ahooks";
import {VscsApi} from "../../services/VscsApi";
import {ArrowLeftOutlined, LeftCircleTwoTone, VerticalRightOutlined} from "@ant-design/icons";

const {Search} = Input;

const {Text} = Typography

let searchPage = 0

const VscsPersonMixPage = () => {
    const navigate = useNavigate()
    const [hasMore, setHasMore] = useState(true)
    const [loading, setLoading] = useState(false)
    const [person, setPerson] = useState({})
    const [persons, setPersons] = useState([])

    const [searchParams] = useSearchParams()
    const personId = searchParams.get("id")

    const searchPerson = (id, replace) => {
        setLoading(true)
        VscsApi.searchPerson(id, searchPage)
            .onSuccess(data => {
                let baseData = []
                if (!replace) {
                    baseData = [...persons]
                }
                setPersons([...baseData, ...data])
                setHasMore(data.length >= 50)
                searchPage++;
            })
            .onComplete(() => {
                setLoading(false)
            })
    }

    useMount(() => {
        VscsApi.person(personId)
            .onSuccess(setPerson)

        searchPerson()
    })

    const handleSearch = (value) => {
        searchPage = 0
        searchPerson(value, true)
    }

    const mapGender = (value) => {
        if (value === "-1") {
            return "未知"
        }
        if (value === "1") {
            return "女"
        }
        if (value === "0") {
            return "男"
        }
        return "无法识别"
    }

    const handlePersonClick = (selectPerson) => {
        Modal.confirm({
            title: '是否确认合并',
            content: <>
                <Space split={<ArrowLeftOutlined />}>
                    <Image
                        height={101}
                        width={101}
                        src={person.properties?.face.imageUrl}
                    />
                    <Image
                        height={101}
                        width={101}
                        src={selectPerson.properties?.face.imageUrl}
                    />
                </Space>
                <p>右侧人物所有关联将合并入左侧人物，右侧人物将会被删除。</p>
            </>,
            okText: '确认',
            cancelText: '取消',
            onOk() {
                VscsApi.mixPerson(person.id, selectPerson.id)
                    .onSuccess(() => {
                        navigate('/vscs/person/faces?id=' + personId, {replace: true})
                    })
            }
        });
    }

    return (
        <>
            <Card title={"基础人物"}
                  style={{marginBottom: 16}}>
                <Space direction="vertical">
                    <Image
                        height={101}
                        width={101}
                        src={person.properties?.face?.imageUrl}
                    />
                    <SimpleTips
                        tips={[
                            "#" + person.id,
                            "推测年龄：" + person.age,
                            "推测性别：" + mapGender(person.gender)
                        ]}
                    />
                </Space>
            </Card>
            <Card title={"被合并人物"}
                  extra={
                      <Search placeholder="通过ID搜索人物" onSearch={handleSearch}/>
                  }>
                <Space wrap>
                    {
                        persons.filter(p => p.id != personId).map(person =>
                            <Card size="small"
                                  hoverable
                                  style={{width: 128}}
                                  onClick={() => handlePersonClick(person)}
                                  cover={<Image
                                      height={101}
                                      preview={false}
                                      src={person.properties?.face.imageUrl}
                                  />}>
                                <Text style={{
                                    fontSize: 13,
                                    margin: 0
                                }}>#{person.id}</Text>
                            </Card>)
                    }
                </Space>
                {
                    hasMore && <Row justify="center" style={{margin: 16}}>
                        <Button loading={loading} onClick={() => searchPerson()}>更多</Button>
                    </Row>
                }
            </Card>
        </>
    )
}


export default VscsPersonMixPage